import { render } from "./Monitoring_Trainee_Attendance.vue?vue&type=template&id=56e192da&ts=true"
import script from "./Monitoring_Trainee_Attendance.vue?vue&type=script&lang=ts"
export * from "./Monitoring_Trainee_Attendance.vue?vue&type=script&lang=ts"

import "./Monitoring_Trainee_Attendance.vue?vue&type=style&index=0&id=56e192da&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__